export default "__VITE_ASSET__BfZG4Dol__"